// extracted by mini-css-extract-plugin
export default {"wrapper":"WalletChoice_wrapper__JUV4K","title":"WalletChoice_title__EdDDG","wallets":"WalletChoice_wallets__l3Tr5","card":"WalletChoice_card__sPFzJ"};